// Global Instructions Rule Applied!
//
// Standalone Consolidated Funds page (/consolidated-funds): the fund-group
// grid. The same section renders embedded below the funds list on the Funds
// screen; the detail screen is FundGroupPage (form-type tab).

import React from 'react'
import { ConsolidatedFundsSection } from './components/ConsolidatedFundsSection.tsx'

export default function ConsolidatedFundsPage(): React.ReactElement {
  return (
    <div className='h-full overflow-y-auto bg-gray-50 p-3'>
      <ConsolidatedFundsSection />
    </div>
  )
}
